const MIN_DATE = new Date("01/01/2021");

const dateColumn = ({
	minDate = MIN_DATE,
	maxDate = "",
	placeholder = "Date",
	name = "date",
} = {}) => ({
	name,
	type: "date-picker" as const,
	placeholder,
	minDate,
	maxDate,
});

export default dateColumn;
